<div
  #trigger
  class="tooltip-trigger"
  (mouseenter)="hovered.set(true)"
  (mouseleave)="hovered.set(false)"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut($event)"
  (click)="onClick()"
  (keydown.escape)="onEscape()"
>
  <ng-content></ng-content>
  @if (show() && parts().length) {
    <ptl-tooltip-bubble #bubble [parts]="parts()" [separator]="separator()" [multiline]="multiline()" />
  }
</div>
